import { Table } from "../../../features/Table";
import { type D1Issuer, issuers_columns } from "./columns";
import { type FilterD1IssuersSchema, FilterD1Issuers } from "./filter";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const D1IssuersTable = () => {
  const { t } = useTranslation(["tables"]);
  return (
    <Table<D1Issuer, FilterD1IssuersSchema>
      label={t(`${Tables.D1_ISSUERS}.title`, { defaultValue: "Issuers" })}
      client={Clients.D1}
      table_name={Tables.D1_ISSUERS}
      columns={issuers_columns}
      filter={<FilterD1Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.D1}/${Tables.D1_ISSUERS}/new`,
        },
      ]}
    />
  );
};
